import TipoTemplateWhatsApp from "@/models/enum/TiposTemplateWhatsApp";
import TemplateWhatsAppModel from "@/models/templateWhatsAppModel";
import nfetch from "@/utils/events/nfetch";

import { IService } from "./base/iService";

export default class TemplateWhatsAppService extends IService<TemplateWhatsAppModel> {
    constructor() {
        super("TemplateWhatsApp");
    }

    public getByTipo(tipo: TipoTemplateWhatsApp, id: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetByTipo?tipo=${tipo}&id=${id}`, {
            method: "get",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        });
    }
}
